import { createFileRoute, Outlet } from "@tanstack/react-router"

// this is for breadcrumbs

export const Route = createFileRoute("/app/resources")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => ({
    getTile: () => t && t("Resources_Title"),
  }),
})
